<template>
  <Modal
    :visible="visible"
    centered
    class="bd-dialog"
    :closable="false"
    v-bind="attrs"
    :width="attrs?.width ?? '800px'"
    :class="fullClass.content"
    @cancel="triggerClose"
  >
    <template #title>
      <div class="bd-dialog__title">
        <div class="bd-dialog__title-text">{{ title }}</div>
        <div class="bd-dialog__trigger" :class="{ 'bd-dialog__trigger--disabled': state.loading }">
          <i class="iconfont" :class="fullClass.icon" @click="state.isFull = !state.isFull" />
          <i class="iconfont icon-close" @click="triggerClose" />
        </div>
      </div>
    </template>
    <spin tip="努力加载中" :spinning="state.loading">
      <div class="bd-dialog__body">
        <slot />
      </div>
    </spin>

    <template #footer>
      <Button v-if="cancelVisible" :disabled="state.loading" @click="triggerClose"> 取消 </Button>
      <Button v-if="confirmVisible" type="primary" :loading="state.loading" :disabled="confirmDisabled" @click="handleConfirm"> 确认 </Button>
      <slot name="extraFooter" />
    </template>
  </Modal>
</template>
<script lang="ts">
import { BdDialogProps } from './props'
import { computed, defineComponent, reactive, toRefs } from 'vue'
import { Modal, Spin, Button } from 'ant-design-vue'
import { useModalDragMove } from './useModalDrag'
export default defineComponent({
  name: 'BdDialog',
  components: {
    Modal,
    Spin,
    Button
  },
  props: BdDialogProps,
  emits: ['update:visible'],
  setup(props, { emit }) {
    const { draggable, visible } = toRefs(props)
    const state = reactive({
      isFull: false,
      loading: false
    })
    useModalDragMove({
      draggable,
      visible
    })
    const fullClass = computed(() => ({
      icon: state.isFull ? 'icon-fullscreen-shrink' : 'icon-fullscreen-expand',
      content: state.isFull ? 'bd-dialog--full' : ''
    }))
    const _close = () => {
      emit('update:visible', false)
    }
    const triggerClose = () => {
      if (props.beforCloseFn !== null) props.beforCloseFn()
      _close()
    }
    const handleConfirm = async () => {
      if (props.confirmFn !== null) {
        state.loading = true
        try {
          await props.confirmFn()
          _close()
        } catch (err) {
          console.log(err)
        }
        state.loading = false
      } else {
        _close()
      }
    }
    return {
      triggerClose,
      handleConfirm,
      state,
      fullClass
    }
  }
})
</script>
<style lang="less">
.bd-dialog {
  border-top: 4px solid @primary-color;

  .ant-modal-body {
    padding: 24px 0;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-text {
      .text-show-row(22px,1);
      flex: 1;
      font-weight: 700;
      user-select: none;
    }
  }

  &__body {
    max-height: 75vh;
    padding: 0 24px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__trigger {
    &--disabled {
      i {
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    i {
      padding-left: 16px;
      color: @gray;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        color: @primary-color;
      }
    }
  }

  &--full {
    width: 100vw !important;
    height: 100vh;
    padding-bottom: 0 !important;
    top: 0 !important;
    left: 0 !important;

    .ant-modal-content {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .ant-modal-body {
      flex: 1;
    }
  }
}
</style>
